// Plain-English idea of what a remnant will actually cover.
// Usable square footage is the truth for a remnant — its bounding size can be misleading.
export const remnantFit = (item) => {
  const sqft = Number(item.sqft) || 0;
  if (sqft >= 25) return "Fits an island top or a run of counter";
  if (sqft >= 15) return "Fits a laundry top or small island";
  if (sqft >= 9) return "Fits a double vanity";
  if (sqft >= 5) return "Fits a single vanity";
  if (sqft > 0) return "Great for a hearth, tabletop or shelf";
  return "Ask us what it will cover";
};
